import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    Output,
    EventEmitter,
    IterableDiffers,
    OnInit
} from '@angular/core';
import {Router} from '@angular/router';
import {StateService} from 'src/app/core/services/state/state.service';
import {ComponentSidebar} from '../../../../../shared/classes/components/component_sidebar';
import {TranslateService} from '@ngx-translate/core';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-idw-matrix-selected-items',
    templateUrl: './idw-matrix-selected-items.component.html',
    styleUrls: ['./idw-matrix-selected-items.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IdwMatrixSelectedItemsComponent extends ComponentSidebar implements OnInit {

    selectedItems: any = [];
    @Input() width = '';

    @Output() removeElmt = new EventEmitter();
    @Output() actionOnRecords = new EventEmitter();
    @Output() completeAction = new EventEmitter();

    action: any;
    iterableDiffer: any;

    maxPerPage = 30; /** mod this */

    constructor(
        private _iterableDiffers: IterableDiffers,
        private changeDetectorRef: ChangeDetectorRef,
        protected stateService: StateService,
        public translateService: TranslateService,
        protected deviceService: DeviceDetectorService,
        protected router: Router) {
            super(stateService, translateService, router, deviceService);
            this.iterableDiffer = this._iterableDiffers.find([]).create(null);
    }

    ngOnInit() {

        this.stateService[this.specificState()].multiselectWatch$.subscribe(
            res => {
                if (res) {
                    this.selectedItems = this.stateService[this.specificState()].multiselect;
                    this.updateList(this.selectedItems, this.maxPerPage);
                    this.changeDetectorRef.markForCheck();
                }
            }
        );
    }

    act() {
        if (this.action) {
            let event = {
                actionType: this.action,
                ids: []
            };
            for (let item of this.selectedItems) {
                event.ids.push(item.id);
            }
            this.actionOnRecords.emit(event);
        }
    }

    removeItem(item) {
        this.stateService[this.specificState()].multiselect.splice(
            this.selectedItems.indexOf(item),
            1
        );
        this.selectedItems = this.stateService[this.specificState()].multiselect;
        this.stateService[this.specificState()].multiselectWatch.next(true);

        this.changeDetectorRef.markForCheck();
    }

    onResize(event) {
        // this.informationVisibility = (event.target.innerHeight < 725);
    }

}
